import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { formatCurrency } from './format';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler,
);

export const CHART = {
  primary: '#0169eb',
  navy: '#09223f',
  grey: '#95a5a6',
  good: '#05973F',
  avg: '#E78D00',
  bad: '#FF3A44',
  purple: '#764ba2',
  pink: '#f093fb',
};

export const baseOptions = ({ currency = false } = {}) => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
      position: 'top',
      labels: { boxWidth: 12, padding: 15, usePointStyle: true },
    },
    tooltip: {
      backgroundColor: 'rgba(9, 34, 63, 0.9)',
      titleColor: '#fff',
      bodyColor: '#fff',
      borderColor: CHART.primary,
      borderWidth: 1,
      cornerRadius: 8,
      callbacks: currency
        ? {
            label: (ctx) =>
              `${ctx.dataset.label}: ${formatCurrency(ctx.raw)}`,
          }
        : {},
    },
  },
  scales: {
    x: { grid: { display: false }, ticks: { maxTicksLimit: 10 } },
    y: {
      beginAtZero: true,
      grid: { color: 'rgba(9, 34, 63, 0.06)' },
      ticks: currency ? { callback: (v) => formatCurrency(v) } : {},
    },
  },
});

export const doughnutOptions = () => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: 'bottom' },
    tooltip: {
      backgroundColor: 'rgba(9, 34, 63, 0.9)',
      titleColor: '#fff',
      bodyColor: '#fff',
      borderColor: CHART.primary,
      borderWidth: 1,
      cornerRadius: 8,
    },
  },
});
